/**
 * One query, two jobs, picked by whether `dates` is set:
 * - With `dates`: that window's Deal ID list (filtered by
 *   `vw_deals.validation_date`). This is what the dropdown shows.
 * - Without `dates`: full history, up to 14 days (the source table expires
 *   older partitions). This is `hasNoClientDeals`, the disabled/tooltip
 *   check. A narrow window can be empty on a line item with real deals, so
 *   only this undated check may trigger the Madhive Supply message.
 *
 * Reads the `pdt_bidstream_deal` PDT, joined as `vw_deals` on
 * `explore_inventory`. Looker rebuilds the PDT every 6 hours; both queries
 * share that staleness.
 *
 * Use this query, not `explore_bidstream_base.deal_id`, for any
 * client-facing Deal ID list: `explore_inventory` excludes
 * `source = 'MADHIVE_PRIVATE'`. `explore_bidstream` has no such filter and
 * would expose Madhive's private-supply deal IDs.
 */
/**
 * The query asks for only the `deal_id` field. Looker should already
 * return distinct values in this case. This function removes duplicate
 * values anyway. This keeps the result correct if a later change adds
 * more fields to the query.
 */
export const parseDealIdOptionsResponse = (rows) => {
    const seen = new Set();
    const options = [];
    rows.forEach((row) => {
        const dealId = row["vw_deals.deal_id"];
        if (!dealId || seen.has(dealId))
            return;
        seen.add(dealId);
        options.push({ id: dealId, name: dealId });
    });
    return options;
};
//# sourceMappingURL=dealIds.js.map